module.exports = __webpack_public_path__ + "img/ps-57.fa42dde7.jpg";